<template>
  <b-container>
    <b-form-group :disabled="changes_disabled">
      <!--       <b-alert
        v-for="warning in current_warnings"
        :key="JSON.stringify(warning)"
        show
        variant="info"
      >
        {{ $t(warning) }}
      </b-alert> -->

      <b-form-group>
        <label>
          <b> {{ $t('table_chosen') }} </b>
        </label>
        <b-form-select v-model="table" :options="table_options" />
      </b-form-group>
      <select-one-column
        :available_columns="all_columns"
        :value="period_column"
        @updated_value="period_column = $event"
      >
        <label>
          <b> {{ $t('periodicity_column') }} </b>
          <span
            v-c-tooltip="$t('periodicity_column_tooltip')"
            class="fas fa-question-circle"
          />
        </label>
      </select-one-column>

      <columns-choice-options
        v-model="index_columns"
        :main_text="$t('index_columns')"
        :available_column_names="all_columns"
      >
        <template #sub_component="props">
          <generic-column-name-edition v-bind="props" v-on="props.listeners" />
        </template>
      </columns-choice-options>

      <b-row>
        <b-col>
          <b-form-group>
            <label>
              <b> {{ $t('history_start') }} </b>
            </label>
            <b-form-input v-model="start" type="number" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <label>
              <b> {{ $t('history_stop') }} </b>
            </label>
            <b-form-input v-model="stop" type="number" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form-group>
  </b-container>
</template>

<i18n>
{
  "en": {
    "history_chosen_tables": "List of chosen tables for history",
    "history_start": "History start",
    "history_stop": "History stop"
  },
  "fr": {
    "history_chosen_tables": "Liste des tables choisies pour l'historique",
    "history_start": "Début de l'historique",
    "history_stop": "Fin de l'historique"
  }
}
</i18n>

<script>
import _ from 'lodash'

import { BasicTableInfoEntity } from '@/components/object_model.js'
import { table_columns } from '@/api/subscriptions.js'

// import {
//   subscription_mixin,
//   brick_mixin,
//   metavariables_tracking_info_mixin,
//   brick_with_single_parent_mixin,
// } from '@/components/mixin.js'
import { global_brick_mixin } from '@/components/mixin.js'
import ColumnsChoiceOptions from './columns_choice_options.vue'
import GenericColumnNameEdition from '@/components/generic_column_name_edition.vue'
import SelectOneColumn from './select_one_column.vue'

// *****************************************************************************

export default {
  name: 'BrickHistory',
  components: {
    ColumnsChoiceOptions,
    GenericColumnNameEdition,
    SelectOneColumn,
  },
  // mixins: [
  //   subscription_mixin,
  //   brick_mixin,
  //   metavariables_tracking_info_mixin,
  //   brick_with_single_parent_mixin,
  // ],
  mixins: [global_brick_mixin],
  // props: [
  //   'brick_id',
  //   'project_id',
  //   'description_name',
  //   'metavariables_dicts_poids',
  // ],
  data() {
    return {
      table: -1,
      index_columns: [],
      period_column: null,
      all_columns: [],

      start: '0',
      stop: '0',
    }
  },
  computed: {
    effective_entry_table_id() {
      let entry_table_id = this.cur_brick.parents_info || []
      let res = -1
      if (entry_table_id.length === 1) {
        res = entry_table_id[0].uid
      }
      return res
    },
    adapted_data() {
      let entry_table_id = []
      if (this.table !== -1) {
        let parent_info_entity_type = new BasicTableInfoEntity()
        parent_info_entity_type.uid = this.table
        entry_table_id = [parent_info_entity_type]
      }
      // N.B PL : Don't know why there is a special case here
      if (this.table === this.effective_entry_table_id) {
        entry_table_id = this.cur_brick.parents_info
      }
      let adapted = {
        uid: this.brick_id,
        parents_info: entry_table_id,
        period_column: this.period_column,
        index_columns: this.index_columns,
        start: _.parseInt(this.start),
        stop: _.parseInt(this.stop),
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(new_val) {
        this.table = this.effective_entry_table_id
        this.index_columns = _.cloneDeep(new_val.index_columns)
        this.period_column = _.cloneDeep(new_val.period_column)
        this.start = String(new_val.start)
        this.stop = String(new_val.stop)
      },
    },

    table: {
      immediate: true,
      async handler(new_val, old_val) {
        if (new_val !== old_val) {
          this.all_columns =
            (await table_columns(this.project_id, new_val)).pipe_object || []
        }
      },
    },
  },
}
</script>
